@let postAtt = postAttachments$ | async;
@let commentsAtt = commentsAttachments$ | async;
@let customAtt = customFieldsAttachments$ | async;
@let screenAtt = screenFieldsAttachments$ | async;
@let selectedAttachment = selectedAttachment$ | async;
<button
    #openMenu="cdkOverlayOrigin"
    cdkOverlayOrigin
    interacta-icon-button
    type="button"
    [icon]="'paperclip'"
    [label]="'AI.ADD_ATTACHMENT' | translate"
    [size]="'small'"
    [style]="'text'"
    (click)="isOpen = !isOpen"
></button>
<interacta-menu-dialog
    [open]="isOpen"
    [origin]="openMenu"
    [positionX]="'after'"
    (closing)="isOpen = false; selectAttachment(null, null)"
>
    <div
        class="max-h-screen-80 w-380 gap-y-16"
        interactaMenuDecorator
        style="max-height: min(42rem, 80vh); min-height: min(32rem, 80vh)"
    >
        <section class="px-16 pt-16">
            <section class="flex items-center gap-x-8">
                <interacta-image
                    alt=""
                    [classes]="'size-24'"
                    [src]="
                        theme === 'dark'
                            ? './assets/shared/images/ai/ai-interacta-logo_dark.svg'
                            : './assets/shared/images/ai/ai-interacta-logo_light.svg'
                    "
                />
                <h2 class="typo-t6">
                    {{ 'AI.ADD_ATTACHMENT' | translate }}
                </h2>
                <button
                    class="ml-auto"
                    interacta-icon-button
                    type="button"
                    [icon]="'close'"
                    [label]="'AI.CLOSE' | translate"
                    [size]="'small'"
                    [style]="'text'"
                    (click)="isOpen = false"
                ></button>
            </section>
            <p class="mt-8 typo-xs">
                {{ 'AI.ADD_ATTACHMENT_DESCRIPTION' | translate }}
            </p>
        </section>
        <interacta-separator [thickness]="'soft'" />
        <section class="flex grow flex-col gap-y-12 overflow-y-auto px-16">
            @if (
                (postAtt?.totalCount ?? 0) +
                    (commentsAtt?.totalCount ?? 0) +
                    (customAtt?.totalCount ?? 0) +
                    (screenAtt?.totalCount ?? 0) <=
                0
            ) {
                <p class="self-center">
                    {{ 'AI.NO_AVAILABLE_ATTACHMENTS' | translate }}
                </p>
                <interacta-image
                    class="self-center"
                    [alt]="'AI.NO_AVAILABLE_ATTACHMENTS' | translate"
                    [classes]="'object-contain shrink-0 h-308'"
                    [src]="'assets/shared/images/doodles/empty-page.png'"
                />
            } @else {
                @if (postAtt && postAtt.totalCount) {
                    <interacta-attachments-selection-list
                        [attachments]="postAtt"
                        [selectedAttachment]="
                            selectedAttachment &&
                            selectedAttachment.entityType === 'post'
                                ? selectedAttachment.attachment.id
                                : null
                        "
                        [title]="'AI.ATTACHMENTS_IN_POST' | translate"
                        (loadMore)="loadMore('post', postAtt.pageTokenInfo)"
                        (selectAttachment)="selectAttachment('post', $event)"
                    />
                }
                @if (customAtt && customAtt.totalCount) {
                    <interacta-attachments-selection-list
                        [attachments]="customAtt"
                        [selectedAttachment]="
                            selectedAttachment &&
                            selectedAttachment.entityType === 'postFilePicker'
                                ? selectedAttachment.attachment.id
                                : null
                        "
                        [title]="'AI.ATTACHMENTS_IN_CUSTOM_FIELDS' | translate"
                        (loadMore)="
                            loadMore('postFilePicker', customAtt.pageTokenInfo)
                        "
                        (selectAttachment)="
                            selectAttachment('postFilePicker', $event)
                        "
                    />
                }
                @if (workflowEnabled && screenAtt && screenAtt.totalCount) {
                    <interacta-attachments-selection-list
                        [attachments]="screenAtt"
                        [selectedAttachment]="
                            selectedAttachment &&
                            selectedAttachment.entityType === 'screenFilePicker'
                                ? selectedAttachment.attachment.id
                                : null
                        "
                        [title]="'AI.ATTACHMENTS_IN_WORKFLOW' | translate"
                        (loadMore)="
                            loadMore(
                                'screenFilePicker',
                                screenAtt.pageTokenInfo
                            )
                        "
                        (selectAttachment)="
                            selectAttachment('screenFilePicker', $event)
                        "
                    />
                }
                @if (commentsAtt && commentsAtt.totalCount) {
                    <interacta-attachments-selection-list
                        [attachments]="commentsAtt"
                        [selectedAttachment]="
                            selectedAttachment &&
                            selectedAttachment.entityType === 'comment'
                                ? selectedAttachment.attachment.id
                                : null
                        "
                        [title]="'AI.ATTACHMENTS_IN_COMMENTS' | translate"
                        (loadMore)="
                            loadMore('comment', commentsAtt.pageTokenInfo)
                        "
                        (selectAttachment)="selectAttachment('comment', $event)"
                    />
                }
            }
        </section>

        <section class="flex justify-end gap-x-16 px-16 pb-16">
            <button
                interacta-button
                type="submit"
                [label]="'AI.CANCEL' | translate"
                (click)="isOpen = false; selectAttachment(null, null)"
            ></button>
            <button
                interacta-button
                type="button"
                [disabled]="!selectedAttachment"
                [label]="'AI.INSERT' | translate"
                [style]="'filled'"
                (click)="sendSelectedAttachmentToAI()"
            ></button>
        </section>
    </div>
</interacta-menu-dialog>
